module.exports = __webpack_public_path__ + "static/media/11.c34dd91c.jpg";